import type { BranchKey } from '@festina-life/api'
import { Button } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { Popover, PopoverButton } from '@festina-life/ui/structure'

import { ActionsMenuPanel } from '../../../actionsPanel/ActionsMenuPanel'
import { BranchTypesForm } from '../BranchTypesForm'

type Props = {
  branchKey: BranchKey
}

export const ChangeBranchTypesButton = ({ branchKey }: Props) => {
  const translate = useTranslate()

  return (
    <Popover>
      <PopoverButton as="div">
        <Button startIcon="PencilSquare">
          {translate('branchDetailsPanel.tabs.advanced.changeTypes')}
        </Button>
      </PopoverButton>
      <ActionsMenuPanel anchor={{ to: 'right' }} className="max-w-lg!">
        <BranchTypesForm branchKey={branchKey} />
      </ActionsMenuPanel>
    </Popover>
  )
}
